import * as ActionTypes from 'state/types'
import { indexOf } from 'shared/utils/array'

const initialState = {
  isRequesting: false,
  isFailure: false,
  collection: []
}

export default (state = initialState, action) => {
  switch (action.type) {
    case `${ActionTypes.INBOXES_REQUEST}_START`: {
      return {
        ...state,
        isRequesting: true,
        isFailure: false,
        collection: []
      }
    }

    case `${ActionTypes.INBOXES_REQUEST}_SUCCESS`: {
      const {
        collection
      } = action.response.payload

      return {
        ...state,
        isRequesting: false,
        isFailure: false,
        collection
      }
    }

    case `${ActionTypes.INBOXES_REQUEST}_FAIL`: {
      return {
        ...state,
        isRequesting: false,
        isFailure: true
      }
    }

    case ActionTypes.RECEIVE_UPDATED_INBOX: {
      const inbox = action.payload?.inbox

      if(!inbox) return state

      const newCollection = [...state.collection]

      const index = indexOf(newCollection, i => i.inboxId === inbox.inboxId)

      if(index > -1) {
        newCollection[index] = inbox
      }

      return {
        ...state,
        collection: newCollection
      }
    }

    default:
      return state
  }
}
